// 客户端组件

'use client';

import Breadcrumbs from '@/components/Breadcrumbs';
import Button from '@/components/Button';
import Image from '@/components/Image';
import { useState } from 'react';
import WritersApplyDialog from './writers-apply-dialog';

function WriteForUsClient({ pageData }: { pageData: any }) {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* 移动端面包屑导航 */}
      <div className="md:hidden absolute top-3 left-3.5 z-50">
        <Breadcrumbs
          items={[{ href: '/', label: 'Home' }, { label: 'Write for us' }]}
          className="text-xs font-normal"
        />
      </div>

      {/* Banner区域 */}
      <section className="relative w-full">
        <Image
          src={pageData.mobile.banner.backgroundImage}
          alt="Write for ZEELOOL"
          width={640}
          height={400}
          className="w-full md:hidden"
          priority
        />
        <Image
          src={pageData.pc.banner.backgroundImage}
          alt="Write for ZEELOOL"
          width={1920}
          height={600}
          className="hidden md:block w-full"
          priority
        />
        <div className="absolute md:right-[10%] md:top-1/2 md:-translate-y-1/2 top-11 right-1/2 -translate-x-1/2 md:translate-x-0 text-center md:text-left ">
          <h1
            className="text-[24px] md:text-[56px] leading-[29px] md:leading-[67px] font-bb text-[#282828]"
            dangerouslySetInnerHTML={{ __html: pageData.pc.banner.title }}
          />
          <h5
            className="mt-[8px] md:mt-[16px] text-[13px] md:text-[24px] leading-[20px] md:leading-[28px] font-br text-[#282828]"
            dangerouslySetInnerHTML={{ __html: pageData.pc.banner.subtitle }}
          />
        </div>
      </section>

      {/* 提交主题区域 */}
      <section className="mt-[68px] md:mt-[120px] mb-[32px] md:mb-[88px] mx-auto px-[14px] md:px-[60px] max-w-[1520px] flex flex-col items-center">
        <div className="relative mb-[68px] md:mb-[120px] text-center">
          <h2
            className="text-[40px] md:text-[80px] leading-[48px] md:leading-[96px] font-bb z-[2] relative"
            dangerouslySetInnerHTML={{ __html: pageData.pc.submit.title }}
          />
          <Image
            src="/static-page/write-for-us/oval.svg"
            alt="oval"
            width={32}
            height={32}
            className="absolute top-[18px] md:bottom-[14px] left-[-18px] md:left-[-40px] z-[1]"
          />
          <Image
            src="/static-page/write-for-us/star.svg"
            alt="star"
            width={32}
            height={32}
            className="absolute bottom-[8px] md:top-[8px] right-0 md:right-[-30px]"
          />
          <Image
            src="/static-page/write-for-us/path.svg"
            alt="path"
            width={100}
            height={32}
            className="absolute -top-5 md:top-0 left-[80%] md:left-[55%] -translate-x-1/2"
          />
        </div>

        <div className="text-center mb-[20px] md:mb-[80px] max-w-[320px] md:max-w-[1020px]">
          <h3
            className="text-[24px] md:text-[40px] leading-[29px] md:leading-[48px] font-bb mb-[8px] md:mb-[16px]"
            dangerouslySetInnerHTML={{ __html: pageData.pc.submit.subtitle }}
          />
          <p
            className="text-[13px] md:text-[16px] leading-[20px] md:leading-[19px] font-br"
            dangerouslySetInnerHTML={{ __html: pageData.pc.submit.description }}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[16px] md:gap-[24px]">
          {pageData.pc.submit.topics.map((item: any, index: number) => (
            <div
              key={item.id ?? index}
              className="bg-[#f5f5f5] rounded-[6px] md:rounded-[12px] p-[20px] md:p-[24px] md:p-12"
            >
              <h4
                className="text-[16px] md:text-[20px] leading-[20px] md:leading-[24px] font-bb mb-[11px] md:mb-[20px]"
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
              <p
                className="text-[13px] md:text-[16px] leading-[20px] md:leading-[24px] text-[#282828] font-ir"
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </div>
          ))}
        </div>
      </section>

      {/* 申请入口区域 */}
      <section className="bg-[#e2dffd] py-[40px] md:py-[56px]">
        <div className="max-w-[302px] md:max-w-[1000px] mx-auto text-center">
          <h2
            className="text-[24px] md:text-[40px] leading-[29px] md:leading-[48px] font-bb mb-[8px] md:mb-[24px]"
            dangerouslySetInnerHTML={{ __html: pageData.pc.apply.title }}
          />
          <p
            className="text-[13px] md:text-[16px] leading-[20px] md:leading-[24px] font-br mb-[36px] md:mb-[28px] max-w-[560px] mx-auto"
            dangerouslySetInnerHTML={{ __html: pageData.pc.apply.description }}
          />
          <Button
            onClick={() => setShowDialog(true)}
            className="w-[302px] md:w-[363px] h-[43px] md:h-[56px] rounded-[22px] md:rounded-[28px] text-[14px] md:text-[16px] leading-[17px] md:leading-[19px] font-bb cursor-pointer"
            style={{
              backgroundColor: pageData.pc.apply.buttonColor,
              color: pageData.pc.apply.buttonTextColor,
            }}
            sx={{
              fontSize: '16px',
              fontFamily: 'var(--font-bricolage-bold)',
              borderRadius: '28px',
            }}
          >
            {pageData.pc.apply.buttonText}
          </Button>
        </div>
      </section>

      {/* 提交要求区域 */}
      <section className="pt-[43px] md:pt-[104px] pb-[88px] flex flex-col items-center px-[14px] pl-[24px] md:px-[60px]">
        <div className="max-w-[1024px] flex flex-col items-center mb-[44px] md:mb-[104px]">
          <h2 className="text-[24px] md:text-[40px] leading-[29px] md:leading-[48px] font-bb mb-[20px] md:mb-[40px] text-center">
            {pageData.pc.requirement.requirements.title}
          </h2>
          <ul className="list-disc">
            {pageData.pc.requirement.requirements.list.map((item: any, index: number) => (
              <li
                key={item.id ?? index}
                className="text-[13px] md:text-[16px] leading-[20px] md:leading-[19px] font-br mb-[16px] md:mb-[24px]"
              >
                <span className="text-[#282828] font-bb">{item.start}</span>
                <span>{item.info}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="max-w-[1024px] flex flex-col items-center mb-[44px] md:mb-[104px]">
          <h3 className="text-[24px] md:text-[40px] leading-[29px] md:leading-[48px] font-bb mb-[24px]">
            {pageData.pc.requirement.compensation.title}
          </h3>
          <p className="text-[13px] md:text-[16px] leading-[20px] md:leading-[19px] font-br">
            {pageData.pc.requirement.compensation.description}
          </p>
        </div>

        <div className="max-w-[1024px] flex flex-col items-center mb-[44px] md:mb-[64px]">
          <h3 className="text-[24px] md:text-[40px] leading-[29px] md:leading-[48px] font-bb mb-[24px]">
            {pageData.pc.requirement.process.title}
          </h3>
          <ul>
            {pageData.pc.requirement.process.list.map((item: any, index: number) => (
              <li
                key={item.id ?? index}
                className="text-[13px] md:text-[16px] leading-[20px] md:leading-[19px] font-br mb-[16px]"
              >
                <span className="text-[#282828] font-bb">{item.start}</span>
                <span>{item.info}</span>
              </li>
            ))}
          </ul>
          <p className="text-[13px] md:text-[16px] leading-[20px] md:leading-[19px] font-br w-full text-left">
            {pageData.pc.requirement.process.description}
          </p>
        </div>

        <Button
          onClick={() => setShowDialog(true)}
          className="w-[302px] md:w-[363px] h-[43px] md:h-[56px] rounded-[22px] md:rounded-[28px] text-[14px] md:text-[16px] leading-[17px] md:leading-[19px] font-bb cursor-pointer"
          style={{
            backgroundColor: pageData.pc.requirement.buttonColor,
            color: pageData.pc.requirement.buttonTextColor,
          }}
          sx={{
            fontSize: '16px',
            fontFamily: 'var(--font-bricolage-bold)',
            borderRadius: '28px',
          }}
        >
          {pageData.pc.requirement.buttonText}
        </Button>
      </section>

      {/* 申请弹窗 */}
      <WritersApplyDialog showDialog={showDialog} onClose={() => setShowDialog(false)} />
    </div>
  );
}

export default WriteForUsClient;
